// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:ds:0lQb7Y */\n.mO1Bu{color:var(--audio-action-link-default);-webkit-text-decoration:underline;text-decoration:underline}.mO1Bu:hover{color:var(--audio-action-link-hovered)}.mO1Bu:active{color:var(--audio-action-link-pressed)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "mO1Bu"
};
export default ___CSS_LOADER_EXPORT___;
